var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  搜索:\n  "),_vm._l((_vm.dynamicTags),function(tag){return _c('el-tag',{key:tag.title,attrs:{"closable":"","disable-transitions":false,"effect":"dark","size":"large"},on:{"close":function($event){return _vm.handleClose(tag)}}},[_vm._v("\n    "+_vm._s(tag.title)+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c59a22a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element_ui/filter_componet/Tag.vue
// module id = null
// module chunks = 